import { render, staticRenderFns } from "./PolicyLibrary.vue?vue&type=template&id=00aa3bae"
import script from "./PolicyLibrary.vue?vue&type=script&lang=js"
export * from "./PolicyLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports